import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth/auth.service';

/**
 * Protects admin routes.
 * Allows access to the admin area: global admins/engineers and resellers.
 * If tenant user → redirect to /dashboard
 * If not logged in → redirect to /login (handled by authGuard before this one)
 */
export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const user = auth.getUser();
  if (!user) {
    return router.createUrlTree(['/login']);
  }

  if (!auth.isAdminArea()) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
